module.exports = __webpack_public_path__ + "img/analytics.107aea80.svg";